import React from "react";

const BG = "/mnt/data/Screenshot 2025-11-15 211316.png";

export default function HeroCard22() {
  return (
    <>
      <section className="acr-hero">

        {/* Background + dark overlay */}
        <div className="acr-bg"></div>
        <div className="acr-overlay"></div>

        {/* Social Bar (Right side) */}
        <aside className="acr-social-bar">
          <div className="acr-sicon close">✕</div>
          <div className="acr-sicon">📷</div>
          <div className="acr-sicon">f</div>
          <div className="acr-sicon">🐦</div>
        </aside>

        {/* Hero Content */}
        <div className="acr-container">

          <h1 className="acr-title">
            Provide Quality <br />
            <span>AC Repair Service</span>
          </h1>

          <p className="acr-desc">
            Nullam hendrerit, lacus nluctus tempu est neque suscipit auvel hendretr 
            ligu sed turpis acus nluctus tempu est neque suscipit kullam hendrerit.
          </p>

          <div className="acr-cta-row">
            <button className="acr-btn">VIEW ALL SERVICES →</button>

            {/* play button */}
            <div className="acr-play-wrapper">
              <div className="acr-play-pulse"></div>
              <div className="acr-play-btn">▶</div>
            </div>

            <span className="acr-video-text">Our Video</span>
          </div>
        </div>
      </section>

      {/* Bottom Info Strip */}
      <section className="acr-info-strip">
        <div className="acr-info-item">
          <h4>Call Us Now!</h4>
          <p>+01234567890</p>
        </div>
        <div className="acr-info-item">
          <h4>Email Us</h4>
          <p>support@company.com</p>
        </div>
        <div className="acr-info-item">
          <h4>Our Timings</h4>
          <p>Mon–Sun: 8AM – 9PM</p>
        </div>
      </section>

      <style>{`
/* -------------------- HERO -------------------- */
.acr-hero {
  position: relative;
  min-height: 92vh;
  padding: 90px 6%;
  color: #fff;
  overflow: hidden;
}

/* bg image */
.acr-bg {
  position: absolute;
  inset: 0;
  background-image: url('${BG}');
  background-size: cover;
  background-position: center;
  z-index: 1;
}

/* dark transparent overlay */
.acr-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0,0,0,0.55);
  z-index: 2;
}

/* container */
.acr-container {
  position: relative;
  z-index: 4;
  max-width: 900px;
  margin-top: 80px;
}

/* hero title */
.acr-title {
  font-size: 3.4rem;
  font-weight: 800;
  line-height: 1.15;
}
.acr-title span {
  color: #18d1e3;
}

/* description */
.acr-desc {
  margin-top: 18px;
  max-width: 680px;
  line-height: 1.6;
  opacity: 0.92;
}

/* CTA Row */
.acr-cta-row {
  margin-top: 35px;
  display: flex;
  align-items: center;
  gap: 20px;
}

/* button */
.acr-btn {
  background: #18d1e3;
  padding: 12px 28px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  color: #002530;
  font-weight: 700;
  font-size: 1rem;
  letter-spacing: 0.5px;
}

/* play button */
.acr-play-wrapper {
  position: relative;
  width: 62px;
  height: 62px;
}

/* ripple/pulse animation */
.acr-play-pulse {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background: rgba(255,255,255,0.15);
  animation: pulse 2s infinite ease-out;
}

@keyframes pulse {
  0% { transform: scale(0.8); opacity: 0.5; }
  70% { transform: scale(1.45); opacity: 0.05; }
  100% { transform: scale(0.8); opacity: 0.5; }
}

/* play circle */
.acr-play-btn {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background: rgba(255,255,255,0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: bold;
}

/* video label */
.acr-video-text {
  font-size: 1rem;
  opacity: 0.85;
}

/* ---------------- RIGHT SOCIAL BAR ---------------- */
.acr-social-bar {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 70px;
  background: #0187b5;
  z-index: 10;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
  align-items: center;
  padding-bottom: 40px;
}

.acr-sicon {
  background: rgba(255,255,255,0.25);
  height: 48px;
  width: 48px;
  border-radius: 50%;
  display:grid;
  place-items:center;
  font-size: 20px;
  cursor:pointer;
}
.acr-sicon.close {
  margin-bottom: 50px;
}

/* ---------------- INFO STRIP ---------------- */
.acr-info-strip {
  background: #0187b5;
  padding: 22px 6%;
  display: flex;
  justify-content: space-between;
  color: #fff;
}

.acr-info-item {
  text-align: center;
}
.acr-info-item h4 {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 700;
}
.acr-info-item p {
  margin: 4px 0 0;
  font-size: 0.95rem;
}

/* responsive */
@media (max-width:910px) {
  .acr-info-strip {
    flex-direction: column;
    text-align:center;
    gap: 20px;
  }
}
      `}</style>
    </>
  );
}
